import React from "react"
import Link from "gatsby-plugin-transition-link"
import Item from "./item"
import * as s from "./index.module.scss"
import SwiperCore, { Controller, Navigation, Scrollbar, A11y } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import { GatsbyImage } from "gatsby-plugin-image"
import "swiper/swiper.scss"
import "../../styles/modules/swiper/scrollbar.scss"
import "../../styles/modules/swiper/navigation.scss"
SwiperCore.use([Controller, Navigation, Scrollbar, A11y])

type Props = {
  posts: GatsbyTypes.ContentfulCasestudy[]
}

const Component: React.FC<Props> = ({ posts }) => {
  return (
    <div className={s.slider}>
      <Swiper
        speed={400}
        spaceBetween={20}
        slidesPerView={1}
        navigation
        // pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        // onSwiper={swiper => console.log(swiper)}
        // onSlideChange={() => console.log("slide change")}
        breakpoints={{
          640: {
            slidesPerView: 2,
            spaceBetween: 25,
          },
          1080: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        }}
        className={s.slide_inner}
      >
        {posts.map((post, index) => (
          <SwiperSlide className={s.slide_item} key={index}>
            <Item post={post} key={index} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Component
